import { Archive } from 'lucide-react'
import { Button, Tooltip } from '@highlight/ui'

/** Left of the status line, so Skip and the CTA keep their Figma positions (HIG-6612). */
export function AskUserDismissButton({ onSelect }: { onSelect: () => void }) {
  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button size="sm" variant="ghost" shape="circle" aria-label="Dismiss" onClick={onSelect}>
            <Archive aria-hidden="true" className="size-4" />
          </Button>
        }
      />
      <Tooltip.Content>Dismiss</Tooltip.Content>
    </Tooltip>
  )
}
